"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _drywall = require("drywall");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../../constants");
var _AlertMixin = require("../../mixins/components/AlertMixin");
var _statusIconAppearance = require("../../util/statusIconAppearance");
var _excluded = ["isOpen", "onClose"];
/**
 * @extends Toast
 * @since 7.21.0
 */
var Alert = /*#__PURE__*/(0, _styledComponents.default)(function (_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    openState = _useState2[0],
    setOpenState = _useState2[1];
  var customizedOnClose = (0, _react.useCallback)(function () {
    setOpenState(false);
    if (onClose) {
      onClose();
    }
  }, [setOpenState, onClose]);
  if (
  // Controlled closed
  typeof isOpen === 'boolean' && !isOpen ||
  // Uncontrolled closed
  typeof isOpen !== 'boolean' && !openState) {
    return null;
  }

  // props onClose and isOpen will not bleed to Toast
  return /*#__PURE__*/_react.default.createElement(_drywall.Toast, (0, _extends2.default)({
    onClose: customizedOnClose
  }, props));
}).withConfig({
  displayName: "Alert",
  componentId: "c11n-8-109-1__sc-1k2e36i-0"
})(["", ""], _AlertMixin.AlertMixin);
exports.Alert = Alert;
Alert.displayName = 'Alert';
Alert.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * An optional `TextButton` action.
   *
   * @ignoreInControls
   */
  actionButton: _propTypes.default.node,
  /**
   * The type of alert to display. By default, `appearance` will also modify the `icon` used.
   */
  appearance: _propTypes.default.oneOf(Object.values(_constants.STATUS_TYPES)).isRequired,
  /**
   * The body content of the alert.
   */
  body: _propTypes.default.node,
  /**
   * In general, you will want to use the `body` prop,
   * but you can use the children prop to override the default component layout.
   * When passing a function, the function will receive all the component props as the only
   * argument (Note: some of the props may have been modified and/or enhanced,
   * so you should always use the values that are passed to the render function).
   *
   * @ignoreInControls
   */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * The close button node. You can set this to `<CloseButton />` if needed.
   * Usability Hint: Enabling the close button is not recommended if there is
   * an appropriate action to help revolve warnings or errors instead.
   *
   * @ignoreInControls
   */
  closeButton: _propTypes.default.node,
  /**
   * Alerts are an [uncontrolled component](https://reactjs.org/docs/uncontrolled-components.html)
   * component by default. You can specify `isOpen` to manually control the visibility of the
   * component.
   *
   * @ignoreInControls
   */
  isOpen: _propTypes.default.bool,
  /**
   * The icon node. By default, this will use an icon based on the alert `appearance`.
   *
   * @ignoreInControls
   */
  icon: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * Alerts should have a role of [status](https://www.w3.org/TR/wai-aria-1.1/#status) or
   * [alert](https://www.w3.org/TR/wai-aria-1.1/#alert) to signal to assistive technologies
   * that it requires the user's attention. In general, you will want to use the less noisy
   * "status" role.
   */
  role: _propTypes.default.oneOf(['status', 'alert'])
} : {};
Alert.defaultProps = {
  appearance: 'info',
  closeButton: null,
  icon: _statusIconAppearance.statusIconAppearance,
  isOpen: null,
  role: 'status'
};

/** @component */